var _g, _g2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgFireExtinguisher = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 449.892 512"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 33",
  fill: "#3c3a41"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 230",
  d: "M299.892 75a14.854 14.854 0 01-15 15h-60a15 15 0 110-30h60a14.853 14.853 0 0115 15z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 231",
  d: "M149.892 75a14.854 14.854 0 01-15 15h-52.8a32.975 32.975 0 00-31.8 24.9l-21 83.7a14.629 14.629 0 01-18 10.8 14.5 14.5 0 01-10.8-18l20.7-83.7A63.031 63.031 0 0141.593 75a61.387 61.387 0 0140.5-15h52.8a14.852 14.852 0 0114.999 15z"
}))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 34",
  fill: "#2b292c"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 232",
  d: "M41.593 75h108.3a14.854 14.854 0 01-15 15h-52.8a32.975 32.975 0 00-31.8 24.9l-21 83.7a14.629 14.629 0 01-18 10.8 14.5 14.5 0 01-10.8-18l20.7-83.7a63.009 63.009 0 0120.4-32.7z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 233",
  d: "M299.892 75a14.854 14.854 0 01-15 15h-60a14.854 14.854 0 01-15-15z"
}))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 234",
  d: "M179.892 0c-28.2 0-52.8 19.8-58.5 47.1l-1.2 4.8a12.3 12.3 0 00-.3 3.3v84.9a14.853 14.853 0 0015 15h90a14.853 14.853 0 0015-15V60a60.178 60.178 0 00-60-60z",
  fill: "#57555c"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 235",
  d: "M134.892 90a45 45 0 1145-45 45.05 45.05 0 01-45 45z",
  fill: "#e1e4fb"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 236",
  d: "M134.892 60a15 15 0 1115-15 15.011 15.011 0 01-15 15z",
  fill: "#57555c"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 237",
  d: "M224.892 155.1h-45V0a60.176 60.176 0 0160 60v80.1a14.853 14.853 0 01-15 15z",
  fill: "#3c3a41"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 238",
  d: "M431.893.3l-150 30a15.09 15.09 0 00-12 14.7v60a15.088 15.088 0 0012 14.7l150 30a15.021 15.021 0 0018-14.7V15a14.9 14.9 0 00-18-14.7z",
  fill: "#57555c"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 239",
  d: "M449.892 75v60a15.021 15.021 0 01-18 14.7l-150-30a15.09 15.09 0 01-12-14.7V75z",
  fill: "#3c3a41"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 240",
  d: "M299.892 240l-59.4 100.5 59.4 49.5v77a44.94 44.94 0 01-45 45h-150a44.94 44.94 0 01-45-45V225a105.115 105.115 0 01105-105h30a105.115 105.115 0 01105 105z",
  fill: "#ed6c7b"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 241",
  d: "M299.892 240l-59.4 100.5 59.4 49.5v77a44.94 44.94 0 01-45 45h-75V120h15a105.115 105.115 0 01105 105z",
  fill: "#d65b72"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 242",
  d: "M134.892 240a14.853 14.853 0 00-15 15v120a14.854 14.854 0 0015 15h165V240z",
  fill: "#e1e4fb"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle 12",
  fill: "#c5c9f7",
  d: "M179.896 240h120v150h-120z"
})));
export default SvgFireExtinguisher;